export const questions = [
	{
		id: 1,
		question: 'ماهي المدة لتجهيز التطبيق؟',
		answer:
			'يتم تجهيز التطبيق في فترة تتراوح بين 2-7 أيام عمل بعد الانتهاء من ادخال بيانات التطبيق من قبلكم.‬ ‫مدة تجهيز التطبيق ورفعه منفصلة عن مدة إنشاء وتفعيل حساب الشركة الخاص بالتاجر على‬ ‫منصة أبل والتي تتراوح بين أسبوعين إلى شهر.‬',
		isOpened: false,
	},
	{
		id: 2,
		question: 'ماهي مراحل إنشاء التطبيق؟',
		answer:
			'يتم تجهيز التطبيق في فترة تتراوح بين 2-7 أيام عمل بعد الانتهاء من ادخال بيانات التطبيق من قبلكم.‬ ‫مدة تجهيز التطبيق ورفعه منفصلة عن مدة إنشاء وتفعيل حساب الشركة الخاص بالتاجر على‬ ‫منصة أبل والتي تتراوح بين أسبوعين إلى شهر.‬',
		isOpened: false,
	},
	{
		id: 3,
		question: 'هل يمكنني التعديل على تصميم التطبيق؟',
		answer:
			'يتم تجهيز التطبيق في فترة تتراوح بين 2-7 أيام عمل بعد الانتهاء من ادخال بيانات التطبيق من قبلكم.‬ ‫مدة تجهيز التطبيق ورفعه منفصلة عن مدة إنشاء وتفعيل حساب الشركة الخاص بالتاجر على‬ ‫منصة أبل والتي تتراوح بين أسبوعين إلى شهر.‬',
	},
	{
		id: 4,
		question: 'هل يتم دفع مبلغ خدمة التطبيق مرة واحدة فقط؟',
		answer:
			'يتم تجهيز التطبيق في فترة تتراوح بين 2-7 أيام عمل بعد الانتهاء من ادخال بيانات التطبيق من قبلكم.‬ ‫مدة تجهيز التطبيق ورفعه منفصلة عن مدة إنشاء وتفعيل حساب الشركة الخاص بالتاجر على‬ ‫منصة أبل والتي تتراوح بين أسبوعين إلى شهر.‬',
		isOpened: false,
	},
	{
		id: 5,
		question: 'هل تشتمل خدمة التطبيق أي تحديثات ومزايا إضافية؟',
		answer:
			'يتم تجهيز التطبيق في فترة تتراوح بين 2-7 أيام عمل بعد الانتهاء من ادخال بيانات التطبيق من قبلكم.‬ ‫مدة تجهيز التطبيق ورفعه منفصلة عن مدة إنشاء وتفعيل حساب الشركة الخاص بالتاجر على‬ ‫منصة أبل والتي تتراوح بين أسبوعين إلى شهر.‬',
		isOpened: false,
	},
	{
		id: 6,
		question: 'هل أحتاج إلى إعادة إدخال منتجات متجري مرة أخرى في التطبيق؟',
		answer:
			'يتم تجهيز التطبيق في فترة تتراوح بين 2-7 أيام عمل بعد الانتهاء من ادخال بيانات التطبيق من قبلكم.‬ ‫مدة تجهيز التطبيق ورفعه منفصلة عن مدة إنشاء وتفعيل حساب الشركة الخاص بالتاجر على‬ ‫منصة أبل والتي تتراوح بين أسبوعين إلى شهر.‬',
		isOpened: false,
	},
];
